/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from "axios";

import { VApplication } from "../application/index";
import { DeviceInfoService } from "./device-info.service";
import {
    FEEDBACK_BUTTON,
    PRODUCT,
    PRODUCT_IMG,
    MODAL_FEEDBACK_CARD,
    PROMO_BUTTON,
    PROVENANCE,
} from "./config/product-view";
import { VIDEO, THUMB_NAIL } from "../assets/images";

const SERVICE_NAME = "product-view-rest.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync("services.DeviceInfoService") as DeviceInfoService;
};

export class ProductViewRestService {
    name = SERVICE_NAME;
    private static instance: ProductViewRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new ProductViewRestService(props);
        }
        return this.instance;
    }
    async init() {}

    _getImages(images: any, videos: any, videoURL: string) {
        let resultImg: any[] = [];

        console.log(`bla promo-video URL :`, `${videoURL}${"#t=0.4"}`)

        videoURL &&
            resultImg.push({
                original: THUMB_NAIL,
                thumbnail: THUMB_NAIL,
                thumbnailHeight: "100",
                thumbnailClass: "image-thumb",
                type: "video",
                embedUrl: `${videoURL}${"#t-0.4"}`,
            });

        // let _videos = [
        //     {src: "https://s3.ap-south-1.amazonaws.com/io.vlinder.trainings/Backend_Architecture_By_Kiran/filename.m3u8"}
        // ]

        // var src = videoURL; ///video url not youtube or vimeo,just video on server
        // var video = document.createElement("video");

        // video.src = src;

        // video.width = 360;
        // video.height = 240;

        // var canvas = document.createElement("canvas");
        // canvas.width = 360;
        // canvas.height = 240;
        // var context = canvas.getContext("2d");

        //     context.drawImage(video, 30, 30, canvas.width, canvas.height);
        //     var dataURI = canvas.toDataURL("image/jpeg");
        //     console.log(`thumbnail:`, dataURI);

        videos &&
            Array.isArray(videos) &&
            videos.forEach((item: any, index: number) => {
                if (item?.src)
                    resultImg.push({
                        original: THUMB_NAIL,
                        thumbnail: THUMB_NAIL,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                        type: "video",
                        embedUrl: `${item?.src}${"#t=0.4"}`,
                    });
            });

        images &&
            Array.isArray(images) &&
            images.forEach((item: any, index: number) => {
                if (item)
                    resultImg.push({
                        original: item,
                        thumbnail: item,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                        type: "image",
                    });
            });

        return resultImg;
    }

    async productview(payload: string) {
        log.info(`in productView service.`, payload);
        try {
            const res = await this.api.post(
                "/provenance/full_provenance/no_auth/",
                {
                    barcode: payload,
                    appMode: "web",
                    scanType: "barcode",
                    // isHashGtin: true,
                    // barcode: "8902967200597",
                    // fssai: "10014022002668",
                    // mfgDate: "27.04.2022",
                    // batch: "2802",
                }
            );
            if (res) {
                let _data = res?.data?.data;
                log.success(`provenance Data:`, _data);
                if (_data)
                    return {
                        v2ProvData: _data,
                        FEEDBACK_BUTTON: _data?.FeedbackButton,
                        PRODUCT: {
                            ...{ ..._data?.product },
                        },
                        PRODUCT_IMG: this._getImages(
                            _data?.product?.images,
                            _data?.product?.videos,
                            _data?.batch?.promoVideoUrl
                        ),
                        MODAL_FEEDBACK_CARD: {
                            ...{ ..._data?.feedbackModal },
                        },
                        PROMO_BUTTON: {
                            ...{ ...PROMO_BUTTON },
                            url: _data?.product?.webUrl,
                        },
                        PROVENANCE: {
                            ...{ ..._data?.provenance },
                        },
                        ALL_PROV_STEP_MAP: _data?.allProvStepMap,
                        GTIN: _data?.product?.gtin,
                        // BATCH: _data?.product?.batch,
                        BATCH: {
                            ..._data?.batch,
                            // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo"
                        },
                        isAgeVerReq: _data?.others?.isAgeVerReq,
                        campaigns: _data?.campaigns
                    };
            }
        } catch (err) {}
    }

    _getMeta = (data: any[]) => {
        let res =
            data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                return {
                    key: item?.label,
                    value: item?.value,
                };
            });
        return res;
    };

    _getPrimaryMeta = (data: any[], productData: any) => {
        /*
         {
                    key: productData?.priceKey,
                    value: productData?.priceValue,
                },
                {
                    key: productData?.qtyKey,
                    value: productData?.qtyValue,
                },
                {
                    key: "Batch",
                    value: productData?.batch,
                },
                {
                    key: productData?.serialKey,
                    value: productData?.serialValue,
                },
                */
        let res: any[] =
            data && Array.isArray(data) && data.length > 0
                ? data.map((item: any, index: number) => {
                      return {
                          key: item?.label,
                          value: item?.value,
                      };
                  })
                : [];
        productData?.priceValue &&
            res.push({
                key: productData?.priceKey,
                value: productData?.priceValue,
            });
        productData?.qtyValue &&
            res.push({
                key: productData?.qtyKey,
                value: productData?.qtyValue,
            });
        productData?.batch &&
            productData?.batch.toLowerCase() !== "default" &&
            res.push({
                key: "Batch",
                value: productData?.batch,
            });
        productData?.serialValue &&
            res.push({
                key: productData?.serialKey,
                value: productData?.serialValue,
            });
        return res;
    };

    _productData = (productData: any, batch: any, detailsData: any) => {
        let _meta: any = this._getPrimaryMeta(
            detailsData?.ProductDetailInfo?.productInfoList,
            productData
        );
        let _secondaryMeta: any = this._getMeta(
            detailsData?.OrganizationInfo?.organizationInfoList
        );
        let _actions: any[] = [
            {
                key: "provenance",
                title: "Provenance Journey",
            },
            {
                key: "feedback",
                title: batch?.promoButtonText1
                    ? batch?.promoButtonText1
                    : "Feedback",
            },
            {
                key: "visit",
                title: batch?.promoButtonText2
                    ? batch?.promoButtonText2
                    : "Visit",
                url: batch?.promoWebsiteUrl,
            },
            // {
            //     key: "details",
            //     title: "View Proof of Authenticity",
            // },
        ];
       
        return {
            idx: "1",
            title: productData?.title,
            subtitle: productData?.subtitle,
            secondaryTitle: detailsData?.OrganizationInfo?.title,
            promoVideoUrl: {
                url: batch?.promoVideoUrl,
                // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo",
            },
            serialNo: "Rare #/1",
            img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            tag: "DIAMOND",
            productCategory: "collectibles",
            category: "diamond",
            price: productData?.priceValue,
            createdBy: {
                userName: detailsData?.OrganizationInfo?.aboutOrgInfo,
                userId: detailsData?.OrganizationInfo?.aboutOrgInfo,
                link: "https://www.diageoindia.com/",
                authProofUrl: "",
            },
            meta: [..._meta],
            secondaryMeta: [..._secondaryMeta],

            actions: _actions,
            images: this._getImages(
                productData?.images,
                productData?.videos,
                batch?.promoVideoUrl
            ),
        };
    };

    async productDetailView(payload: any) {
        try {
            const res = await this.api.post(
                "/provenance/product_cred/no_auth/",
                {
                    //gtin: payload?.gtin,
                    gtin: "8902967200597",
                }
            );
            if (res) {
                let _detailsData = res?.data?.data?.productDetails;
                let _data = payload?.v2ProvData;
                log.blue(`v2ProvData`, payload?.v2ProvData);
                let firstProv =
                    _data?.provenance?.data &&
                    Array.isArray(_data?.provenance?.data) &&
                    _data?.provenance?.data.length > 0 &&
                    _data?.provenance?.data[0];
                firstProv =
                    firstProv?.data &&
                    Array.isArray(firstProv?.data) &&
                    firstProv?.data.length > 0 &&
                    firstProv?.data[0];
                if (_data)
                    return {
                        // pagination: {
                        //     nextOffset: offset + _found.length,
                        //     totalItems: TEST_DATA?.length,
                        // },
                        ...res?.data?.data,
                        ...this._productData(
                            _data?.product,
                            _data?.batch,
                            _detailsData
                        ),
                        campaigns: _data?.campaigns,
                        firstProv: firstProv,
                        MODAL_FEEDBACK_CARD: {
                            ...{ ..._data?.feedbackModal },
                        },
                        GTIN: _data?.product?.gtin,
                        BATCH: {
                            ..._data?.batch,
                            // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo"
                        },
                        FEEDBACK_BUTTON: _data?.FeedbackButton,
                        PRODUCT: {
                            ...{ ..._data?.product },
                        },
                        PRODUCT_IMG: this._getImages(
                            _data?.product?.images,
                            _data?.product?.videos,
                            _data?.batch?.promoVideoUrl
                        ),
                        PROMO_BUTTON: {
                            ...{ ...PROMO_BUTTON },
                            url: _data?.product?.webUrl,
                        },
                        PROVENANCE: {
                            ...{ ..._data?.provenance },
                        },
                        ALL_PROV_STEP_MAP: _data?.allProvStepMap,
                        isAgeVerReq: _data?.others?.isAgeVerReq,
                        ageDetails:
                            _data?.others?.age_popup_details
                                ?.ageVerifcationData,
                    };
                // if (_data)
                //     return {
                //         PRODUCT_IMG: this._getImages(
                //             _data?.ProductImages?.productImages
                //         ),
                //         ORGANIZATION_INFO: _data?.OrganizationInfo,
                //         PRODUCT_DETAIL_INFO: _data?.ProductDetailInfo,
                //         PRODUCT_TITLE_CARD: _data?.ProductTitleCard
                //     };
            }
            // let _data = {
            //     PRODUCT_IMG,
            //     ORGANIZATION_INFO,
            //     PRODUCT_DETAIL_INFO,
            //     PRODUCT_TITLE_CARD,
            // };
            // return _data;
        } catch (err) {}
    }

    async productTos(payload: any) {
        log.blue(`ageDetail :`, payload?.ageDetails);
        try {
            const res = await this.api.post("/vlinder-core/tos/no_auth", {
                gtin: payload?.gtin,
                action: "age_verification",
                service_agreement: payload?.ageDetails,
            });
            if (res) {
                let _data = res?.data?.data;
                return _data;
            }
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
